import { RemoteRejectedByProfessionals } from 'data/usecases';
import { HandleRejectedByProfessionalsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlRejectedByProfessionals } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleRejectedByProfessionals =
  (): HandleRejectedByProfessionalsUseCaseInterface =>
    new RemoteRejectedByProfessionals(
      makeApiUrlRejectedByProfessionals(),
      makeAxiosHttpClient(),
    );
